var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "41px",
    viewBox: "0 0 31 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_data report_4072256") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accueil---Recherche---autocompletion-fact",
    transform: "translate(-1547.000000, -882.000000)",
    fill: "#323232",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-2",
    transform: "translate(1466.000000, 860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_data-report_4072256",
    transform: "translate(81.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7214527,0 L8.47077451,0 L0,9.51332258 L0,37.72 C0,39.5279677 1.47197065,41 3.27986273,41 L27.7201302,41 C29.5280222,41 31,39.5279677 31,37.72 L31,3.28 C31.0026379,1.47203226 29.5293448,0 27.7214527,0 Z M29.0730735,37.72 C29.0730735,38.4646129 28.4660344,39.0703548 27.7227752,39.0703548 L3.28118526,39.0703548 C2.53528099,39.0703548 1.93088693,38.4632903 1.93088693,37.72 L1.93088693,10.3306774 L7.91266884,10.3306774 C9.1915508,10.3306774 10.2270881,9.29509677 10.2270881,8.01616129 L10.2270881,1.92964516 L27.7214527,1.92964516 C28.4660344,1.92964516 29.071751,2.53670968 29.071751,3.28 L29.071751,37.72 L29.0730735,37.72 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 7,
    y: 19,
    width: 3,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 12,
    y: 21,
    width: 3,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 16,
    y: 16,
    width: 3,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 22,
    y: 10,
    width: 3,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 5,
    y: 29,
    width: 21,
    height: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.33bc190cf977e0846d408935d3f33f6e.svg";
export { ForwardRef as ReactComponent };